import AppTypography from '../../typography/Typography';

/**
 * Renders an informational footer note inside the modal body (above the action buttons).
 *
 * @param {Object} props
 * @param {string} [props.footerNote]
 */
export default function PopupFooter({ footerNote }) {
  if (!footerNote) return null;
  return (
    <AppTypography variant="caption" color="secondary" className="dynamic-popup__footer-note">
      {footerNote}
    </AppTypography>
  );
}
